import * as React from "react";
import { forwardRef } from "react";
const SvgGaugeArrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 26, viewBox: "0 0 24 26", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.5 12.134L2 13L3.5 13.866L18.5 22.5263L20 23.3923L20 21.6603L20 4.33974L20 2.60769L18.5 3.47372L3.5 12.134Z", fill: "white", stroke: "black", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgGaugeArrowLeft);
export { ForwardRef as ReactComponent };
